import React from 'react'
import Header from '../component/Header'
import { useLocation } from 'react-router-dom';
import ExploreResultLocations from '../component/ExploreResultLocations'
import Footer from '../component/Footer'
import HeroBannerSection from '../component/HeroBannerSection'
import WhyPreQualified from '../component/WhyPreQualified'
import QuestionsCTA from '../component/QuestionsCTA'
import GetPreQualifiedComp from '../component/GetPreQualifiedComp' 
import { usePageContent } from "../hooks/usePageContent"; 
import { ASSETS_URL } from "../api/constants";

function GetPreQualified() {
  const { content, loading } = usePageContent("get-pre-qualified");
  const location = useLocation();
  const hideHero = location.state?.hideHero || false;
  
  // Parse the dynamic content
  const dynamicContent = content?.data?.get_pre_qualified_section 
    ? JSON.parse(content.data.get_pre_qualified_section) 
    : null;

  return (
    <>
      <div className='main get-pre-qualified-page'>
        <Header/>
        {!hideHero && <HeroBannerSection content={dynamicContent?.section_1} />}
        {hideHero && <GetPreQualifiedComp />}
        <WhyPreQualified content={dynamicContent?.section_2} />
        <QuestionsCTA content={dynamicContent?.section_3} />
        <ExploreResultLocations />
        <Footer />
      </div>
    </>
  )
}

export default GetPreQualified